import { useEffect, useRef, useState } from 'react';

    type OnIntersection = (isIntersecting: boolean, ob: IntersectionObserver, entry) => boolean | void;
    
    const DefaultOptions: IntersectionObserverInit = {
        root: null,
        threshold: 0,
    }
    
    const DefaultOnIntersection: OnIntersection = (isIntersecting, ob, entry) => {
        if (isIntersecting) return false;
    }
    
    export function useIntersection(onIntersection: OnIntersection = DefaultOnIntersection, 
        options: IntersectionObserverInit = DefaultOptions) {
        const [isIntersecting, setIsIntersecting] = useState(false);
        const elemRef = useRef<null | Element| undefined>(null);
        const setElem = (elem:any) => {
            elemRef.current = elem;
        }
    
        useEffect(() => {
            if (!elemRef.current) return;
            let isUnmounted = false;
            const ob = new IntersectionObserver(([entry]) => {
                if (isUnmounted) return;
                const isElementIntersecting = entry.isIntersecting;
                if (onIntersection(isElementIntersecting, ob, entry) === false) {
                    ob.disconnect();
                };
                setIsIntersecting(isElementIntersecting)
    
            }, { ...options })
            ob.observe(elemRef.current);
            return () => {
                ob.disconnect();
                isUnmounted = true;
            }
        }, [elemRef.current, options]);
    
        return [isIntersecting, setElem] as const;
    }
    